/**
 * Sticky Header Management Class
 *
 * This class manages a sticky header effect on the webpage. It adds or removes a
 * CSS class to the body based on the user's scroll position, enhancing the user
 * experience by keeping the header visible when scrolling down.
 *
 * Properties:
 * - options: Configuration options including the header element and the sticky class name.
 * - data: Internal data tracking the previous scroll position.
 *
 * Functions:
 * - init(): Initializes the sticky header by capturing the initial scroll position and
 *   setting up the scroll event listener.
 * - onScroll(): Handles the scroll event, adding or removing the sticky class based
 *   on the current scroll position relative to the header height.
 *
 * Example:
 * document.addEventListener('DOMContentLoaded', () => new StickyHeader().init());
 */

import Swiper from 'swiper';
import { Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards } from 'swiper/modules';

import "../scss/styles.scss";

import Dropdown from '../../../../node_modules/bootstrap/js/src/dropdown.js';

const swiperModules = [Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards];

/*START Navigation*/

const hamburgerBtn = document.querySelector('.hamburgerBtn');
const body = document.querySelector('body');

function updateBodyOverflow() {
  const isMobile = window.innerWidth < 1200;
  const isExpanded = hamburgerBtn?.getAttribute('aria-expanded') === 'true';

  if (isMobile && isExpanded) {
    body.classList.add('overflow-hidden');
  } else {
    body.classList.remove('overflow-hidden');

  }
}


hamburgerBtn?.addEventListener('click', () => {
  updateBodyOverflow();
});


window.addEventListener('resize', updateBodyOverflow);


document.addEventListener('DOMContentLoaded', updateBodyOverflow);
function handleResponsiveDropdowns() {
  const isDesktop = window.innerWidth >= 1200;

  if (isDesktop) {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-bs-toggle="dropdown"], .dropdown-toggle-custom, .navbar-toggler')) {
        document.querySelectorAll('.nav-link.dropdown.active').forEach(nav => {
          nav.classList.remove('active');
        });

        document.querySelectorAll('.navbar-nav.active').forEach(nav => {
          nav.classList.remove('active');
        });
      }
    });

    document.querySelectorAll('[data-bs-toggle="dropdown"], .dropdown-toggle-custom').forEach(el => {
      let existingInstance = Dropdown.getInstance(el);
      if (existingInstance) {
        existingInstance.dispose();
      }

      const newEl = el.cloneNode(true);
      el.parentNode.replaceChild(newEl, el);

      newEl.setAttribute('data-bs-toggle', 'dropdown');
      newEl.classList.remove('dropdown-toggle-custom');

      const dropdownInstance = new Dropdown(newEl);

      newEl.addEventListener('click', (e) => {
        const parentNavLink = newEl.closest('.nav-link.dropdown');
        const navbarNav = newEl.closest('.navbar-nav');

        const dropdownMenu = newEl.nextElementSibling;

        const isCurrentlyActive = parentNavLink?.classList.contains('active');
        const isCurrentlyOpen = dropdownMenu?.classList.contains('show');

        document.querySelectorAll('.nav-link.dropdown.active').forEach(nav => {
          if (nav !== parentNavLink) {
           nav.classList.remove('active');
          }
        });

        document.querySelectorAll('.navbar-nav.active').forEach(nav => {
          if (nav !== navbarNav) {
            nav.classList.remove('active');
          }
        });

        if (parentNavLink) {
          if (isCurrentlyActive || isCurrentlyOpen) {
            parentNavLink.classList.remove('active');
            if (navbarNav) {
              navbarNav.classList.remove('active');
            }
          } else {
            parentNavLink.classList.add('active');
            if (hamburgerBtn) hamburgerBtn.setAttribute('aria-expanded', 'true');
            if (navbarNav) {
              navbarNav.classList.add('active');
            }
          }
        }
        dropdownInstance.toggle();
      });
    });
  } else {
    const nav = document.querySelector('#navigation-main');


    if (nav && hamburgerBtn) {
      if (nav.classList.contains('show')) {
        hamburgerBtn.setAttribute('aria-expanded', 'true');
      } else {
        hamburgerBtn.setAttribute('aria-expanded', 'false');
      }
    }
    document.querySelectorAll('[data-bs-toggle="dropdown"], .dropdown-toggle-custom').forEach(el => {
      let existingInstance = Dropdown.getInstance(el);
      if (existingInstance) {
        existingInstance.dispose();
      }

      const newEl = el.cloneNode(true);
      el.parentNode.replaceChild(newEl, el);

      newEl.removeAttribute('data-bs-toggle');
      newEl.classList.add('dropdown-toggle-custom');

      const dropdownInstance = new Dropdown(newEl);

      document.querySelectorAll('.nav-link.dropdown.active').forEach(nav => {
        document.querySelector('.navbar-collapse').classList.add('show');
      });

      newEl.addEventListener('click', (e) => {
        const parentNavLink = newEl.closest('.nav-link.dropdown');
        const navbarNav = newEl.closest('.navbar-nav');
        const dropdownMenu = newEl.nextElementSibling;

        const isCurrentlyActive = parentNavLink?.classList.contains('active');
        const isCurrentlyOpen = dropdownMenu?.classList.contains('show');

        document.querySelectorAll('.nav-link.dropdown.active').forEach(nav => {
          if (nav !== parentNavLink) {
            nav.classList.remove('active');
          }
        });

        document.querySelectorAll('.navbar-nav.active').forEach(nav => {
          if (nav !== navbarNav) {
            nav.classList.remove('active');
          }
        });

        if (parentNavLink && dropdownMenu) {
          if (isCurrentlyActive || isCurrentlyOpen) {
            parentNavLink.classList.remove('active');
            if (navbarNav) {
              navbarNav.classList.remove('active');
            }
          } else {
            parentNavLink.classList.add('active');
            if (navbarNav) {
              navbarNav.classList.add('active');
            }
          }
        }
        dropdownInstance.toggle();
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', handleResponsiveDropdowns);
window.addEventListener('resize', handleResponsiveDropdowns);
/*END Navigation*/

/*START download*/
document.querySelectorAll('a.btn-download').forEach(el => {
  el.setAttribute('download', '');
});
/*END download*/

/*START frame-type-sitepackage_imgslider*/
if(document.querySelectorAll('.frame-type-sitepackage_imgslider').length){
  var imgSlider = document.querySelectorAll('.frame-type-sitepackage_imgslider');
  imgSlider.forEach(function(element) {
    const swiperContainer = element.querySelector('.swiper');
    const swiper = new Swiper(swiperContainer, {
      modules: swiperModules,
      slidesPerView:1,
      spaceBetween: 15,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 2.2,
        },
        576: {
          slidesPerView: 1.2,
        },
      }
    });
  });
}
/*END frame-type-sitepackage_imgslider*/


/*START referenzen-related */
if(document.querySelectorAll('.news-related').length){
  var newsRelated = document.querySelectorAll('.news-related');
  newsRelated.forEach(function(element) {
    const newsRelatedSwiperContainer = element.querySelector('.swiper');

    const swiperNewsRelated = new Swiper(newsRelatedSwiperContainer, {
      modules: swiperModules,
      slidesPerView:1,
      spaceBetween: 15,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 2,
        },
      }
    });
  });
}
/*END referenzen-related */

/*START frame-type-sitepackage_horizontaltimeline*/
if (document.querySelectorAll('.frame-type-sitepackage_horizontaltimeline').length) {
  var elementimageVideoModule = document.querySelectorAll('.frame-type-sitepackage_horizontaltimeline');

  elementimageVideoModule.forEach(function(element) {
    const thumbsContainer = element.querySelector('.datumSlider.swiper');
    const datumSlider = new Swiper(thumbsContainer, {
      modules: swiperModules,
      initialSlide: 0,
      spaceBetween: 0,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        1200: { slidesPerView: 5 },
        992:  { slidesPerView: 4 },
        500:  { slidesPerView: 3 },
      }
    });

    const mainContainer = element.querySelector('.contentSlider.swiper');
    const contentSlider = new Swiper(mainContainer, {
      modules: swiperModules,
      effect: "fade",
      spaceBetween: 0,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: element.querySelector(".swiper-button-next"),
        prevEl: element.querySelector(".swiper-button-prev"),
      },
      thumbs: {
        swiper: datumSlider,
      },
    });
  });
}
/*END frame-type-sitepackage_horizontaltimeline*/




document.addEventListener('DOMContentLoaded', function () {
/*START frame-type-sitepackage_timeline*/
  if (document.querySelectorAll('.frame-type-sitepackage_timeline').length) {
    const timelines = document.querySelectorAll('.frame-type-sitepackage_timeline');

    function getBreakpoint() {
      const width = window.innerWidth;
      if (width >= 1200) return 'desktop';
      if (width >= 768) return 'tablet';
      return 'mobile';
    }

    let offset = 250;
    let lastBreakpoint = getBreakpoint();

    function updateOffsetForBreakpoint(breakpoint) {
      if (breakpoint === 'desktop') {
        offset = 250;
      } else if (breakpoint === 'tablet') {
        offset = 200;
      } else {
        offset = 500;
      }
    }

    updateOffsetForBreakpoint(lastBreakpoint);

    timelines.forEach(function (timeline) {
      const textContentDivs = timeline.querySelectorAll('.textContent > .text');

      function checkClosestToTop() {
        const windowHeight = window.innerHeight;
        let closest = null;
        let closestDistance = Infinity;

        textContentDivs.forEach(function (div) {
          const rect = div.getBoundingClientRect();
          const adjustedTop = rect.top - offset;
          const distanceToTop = Math.abs(adjustedTop);

          if (rect.top >= 0 && rect.top < windowHeight) {
            if (distanceToTop < closestDistance) {
              closest = div;
              closestDistance = distanceToTop;
            }
          }
        });

        textContentDivs.forEach(div => div.classList.remove('active'));
        if (closest) {
          closest.classList.add('active');
        }
      }

      window.addEventListener('scroll', checkClosestToTop);

      window.addEventListener('resize', () => {
        const currentBreakpoint = getBreakpoint();
        if (currentBreakpoint !== lastBreakpoint) {
          lastBreakpoint = currentBreakpoint;
          updateOffsetForBreakpoint(currentBreakpoint);
          checkClosestToTop();
        }
      });
      checkClosestToTop();
    });
  }
  /*END frame-type-sitepackage_timeline*/


/*START TAB-ACCORDION*/
  if (document.querySelectorAll('.frame-type-sitepackage_tab').length){
    document.querySelectorAll('.frame-type-sitepackage_tab').forEach(function(sitepackageTab) {
      let accordionSetup = false;

      function setupAccordion() {
        const isMobile = window.innerWidth < 768;

        if (isMobile && !accordionSetup) {
          accordionSetup = true;

          sitepackageTab.querySelectorAll('.tab-pane').forEach(function(pane) {
            pane.classList.remove('show', 'active');
          });

          sitepackageTab.querySelectorAll('.accordion').forEach(function(element) {
             element.accordionHandler = function () {
              const targetTabId = this.getAttribute('data-accordion');
              const targetTab = sitepackageTab.querySelector('#' + targetTabId);

              if (targetTab) {
                const isCurrentlyActive = targetTab.classList.contains('active');

                sitepackageTab.querySelectorAll('.tab-pane').forEach(function(pane) {
                  pane.classList.remove('show', 'active');
                });
                sitepackageTab.querySelectorAll('.accordion').forEach(function(acc) {
                  acc.classList.remove('active');
                });

                if (!isCurrentlyActive) {
                  this.classList.add('active');
                  targetTab.classList.add('active');
                }
              }
            };
            element.addEventListener('click', element.accordionHandler);
          });

        } else if (!isMobile && accordionSetup) {
          accordionSetup = false;

          sitepackageTab.querySelectorAll('.accordion').forEach(function(element) {
            element.classList.remove('active');
            element.removeEventListener('click', element.accordionHandler);
          });

          sitepackageTab.querySelectorAll('.nav-tabs .nav-link').forEach(function(navTab, index) {
            navTab.classList.remove('active');
            if (index === 0) {
              navTab.classList.add('active');
            }
          });

          sitepackageTab.querySelectorAll('.tab-pane').forEach(function(pane, index) {
            pane.classList.remove('active', 'show');
            if (index === 0) {
              pane.classList.add('active', 'show');
            }
          });
        }
      }

      window.addEventListener('resize', setupAccordion);
      setupAccordion();
    });
  }
/*END TAB-ACCORDION*/


/*START News button load-more*/
  function initializeLoadMore(containerSelector, articleSelector, buttonSelector, initialCount) {
    const containers = document.querySelectorAll(containerSelector);
    containers.forEach(container => {
      let articleContainer = container.querySelector(".row");
      let articles = articleContainer ? articleContainer.querySelectorAll(articleSelector) : [];
      let loadMoreButton = container.querySelector(buttonSelector);
      let visibleCount = initialCount;

      function showArticles(count) {
        articles.forEach((article, index) => {
          const parentCol = article.closest('.col-12');
          if (parentCol) {
            parentCol.style.display = index < count ? "block" : "none";
          }
        });

        if (loadMoreButton) {
          loadMoreButton.style.display = count >= articles.length ? "none" : "block";
        }
      }

      if (articles.length > 0) {
        showArticles(visibleCount);

        if (loadMoreButton) {
          loadMoreButton.addEventListener("click", function (e) {
            e.preventDefault();
            visibleCount += initialCount;
            showArticles(visibleCount);
          });
        }
      }
    });
  }

  if (document.querySelectorAll('.tab-pane').length) {
    initializeLoadMore(".tab-pane", ".article", ".load-more", 9); // 4 Artikel initial (1 Reihe à 4 Spalten)
  }

  function hideElementAfterDelay(element, delay) {
    setTimeout(function() {
      element.style.display = 'none';
    }, delay);
  }
  /*END News button load-more*/


 /*START references-detail-page*/
  if ( document.querySelectorAll('.button-back').length) {
    document.querySelector('.button-back').addEventListener('click', function(event) {
      const referrerUrl = document.referrer;
      this.href = referrerUrl;
    });
  }

  document.querySelectorAll('.frame-type-news_pi1 .nav-tabs button').forEach(function (tabButton) {
    tabButton.addEventListener('click', function () {
      const target = tabButton.getAttribute('data-bs-target');

      if (target) {
        const tabId = target.replace('#', '');

        const url = new URL(window.location.href);
        url.searchParams.set('activeTab', tabId);

        window.history.replaceState({}, '', url);
      }
    });
  });


  /*START frame-type-news_pi1*/
  if (document.querySelectorAll('.frame-type-news_pi1').length) {
    const query = window.location.search;
    const params = new URLSearchParams(query);

    const tabIds = [];

    document.querySelectorAll('.frame-type-news_pi1 .nav-tabs button').forEach(function (tabButton) {
      const target = tabButton.getAttribute('data-bs-target');
      if (target) {
        const cleanTarget = target.replace('#', '');
       tabIds.push(cleanTarget);
      }
    });

    let activeTabId = null;

    if (params.has('activeTab') && tabIds.includes(params.get('activeTab'))) {
      activeTabId = params.get('activeTab');
    } else {
      activeTabId = tabIds.find(id => params.has(id));
    }

    if (activeTabId) {
      document.querySelectorAll('.news .nav-tabs > button.active').forEach(el => {
        el.classList.remove('active');
        el.setAttribute('aria-selected', 'false');
      });

      document.querySelectorAll('.tab-content .tab-pane.active.show').forEach(el => {
        el.classList.remove('active', 'show');
      });

      const navTrigger = document.querySelector(`[data-bs-target="#${activeTabId}"]`);
      const tabTrigger = document.querySelector(`#${activeTabId}`);

      if (navTrigger && tabTrigger) {
        navTrigger.classList.add('active');
        navTrigger.setAttribute('aria-selected', 'true');
        tabTrigger.classList.add('active', 'show');
      }
    }
  }
  /*END frame-type-news_pi1*/

/* START Navigation aria-current-page*/
  const currentUrl = window.location.href;
  const regex = /references-tab-\d+/;
  const match = currentUrl.match(regex);

  if (match) {
    let tabId = match[0];
    let navLinks = document.querySelectorAll('a[href*="references-tab-"]');
    navLinks.forEach(link => {
      navLinks.forEach(link => {
        let href = link.getAttribute('href');
        if (link.getAttribute('aria-current') === 'page') {
          link.removeAttribute('aria-current');
        }
        if (href.includes(tabId)) {
          link.setAttribute('aria-current', 'page');
          let parentDropdown = link.closest('.dropdown');
          if (parentDropdown) {
            let topLevelLink = parentDropdown.querySelector('a');
            topLevelLink.setAttribute('aria-current', 'page');
          }
        }
      });
    });
  }
  /*END Navigation aria-current-page*/
});

